// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Tasks__View[data-v-5412c88e] {\r\n  height: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
